import { browser } from "$app/environment";
import { writable } from "svelte/store";

/** Load a `value` from local storage based on a `key`, with a sane default if missing/invalid.
 *
 * In server contexts it returns the default value.
 *
 * Any update are then saved back to local storage.
 * */
export const localStorageStore = <T>(key: string, defaultValue: T) => {
  let value: T;
  //  can't run in server, just return default value
  if (!browser) {
    return writable<T>(defaultValue);
  }
  try {
    value = JSON.parse(window.localStorage.getItem(key) || JSON.stringify(defaultValue));
  } catch (e) {
    console.error(
      `localStorageStore: An error occurred when deserialising '${key}' from localStorage. ${e}`
    );
    // set to default if parsing failed
    value = defaultValue;
  }
  const store = writable<T>(value);
  // subscribe to the store and save the value to localStorage
  store.subscribe((value: T) => window.localStorage.setItem(key, JSON.stringify(value)));
  return store;
};
